import { CanMatchFn, Route, UrlSegment } from "@angular/router";

export const authMatchGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
    return true;
}